<template>
  <div class="card" v-if="stats">
    <div class="card-header">
      <h4 class="card-title" v-if="server">
        <span>Grab Server {{ server.hostname || '' }}</span>
        <div class="label label-info" v-if="server.type === 1">Grab</div>
        <div class="label label-success" v-if="server.type === 2">VOD</div>
      </h4>
    </div>
    <vue-tabs class="card-content">
      <v-tab title="Statistics">
        <div class="row">
          <div class="col-md-8">
            <vue-tabs @tab-change="redrawCharts()">
              <v-tab title="Grabbing" v-if="server.type !== 2">
                <thread-grab-chart ref="grabChart" :thread-data="threadData" :intervals="stats.intervals"/>
              </v-tab>
              <v-tab title="Postprocessing">
                <thread-mdb-chart ref="mdbChart" :thread-data="threadData" :intervals="stats.intervals"/>
              </v-tab>
              <v-tab title="Load">
                <thread-load-chart ref="loadChart" :thread-data="threadData" :intervals="stats.intervals"/>
              </v-tab>
            </vue-tabs>
          </div>
          <div class="col-md-4">
            <el-table :data="stats.threads" highlight-current-row ref="grabJobThread" @current-change="selectThread" height="530">
              <el-table-column label="Thread" width="120">
                <template slot-scope="scope">
                  <strong>Thread {{ scope.row.thread }}</strong>
                  <span class="label label-default" v-if="scope.row.status === 1">Preparing</span>
                  <span class="label label-info" v-if="scope.row.status === 2">Grabbing</span>
                  <span class="label label-warning" v-if="scope.row.status === 3">Postprocess</span>
                  <span class="label label-danger" v-if="scope.row.status === 4">Parsing</span>
                  <span class="label label-success" v-if="scope.row.status === 9">Done</span>
                  <!--                  <span class="label label-success" v-if="scope.row.status === 10">Done</span>-->
                  <span class="label label-danger" v-if="scope.row.status === 10">Error</span>
                </template>
              </el-table-column>
              <el-table-column width="60">
                <template></template>
              </el-table-column>
              <el-table-column align="center">
                <template slot-scope="scope">
                  <div class="text-left" v-if="scope.row.status === 1"><em>Grabbing process will begin shortly.</em>
                  </div>
                  <div class="text-left" v-if="scope.row.status === 2">
                    <strong>{{ getPercent(scope.row.grabCount, scope.row.grabTotal) }}%</strong>
                    <small>({{ scope.row.grabCount }} / {{ scope.row.grabTotal }})</small>
                    <div class="progress">
                      <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-info" :style="{width: getPercent(scope.row.grabCount, scope.row.grabTotal)+'%'}"></div>
                    </div>
                  </div>
                  <div class="text-left" v-if="scope.row.status === 3">
                    <strong>{{ getPercent(scope.row.mdbCount, scope.row.mdbTotal) }}%</strong>
                    <small>({{ scope.row.mdbCount }} / {{ scope.row.mdbTotal }})</small>
                    <div class="progress">
                      <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-warning" :style="{width: getPercent(scope.row.mdbCount, scope.row.mdbTotal)+'%'}"></div>
                    </div>
                  </div>
                  <div class="text-left" v-if="scope.row.status === 4"><em>Uploading and parsing grabbed data</em></div>
                  <div class="text-left" v-if="scope.row.status === 9"><em>Grabbed data was processed.</em></div>
                  <!--                  <div class="text-left" v-if="scope.row.status === 10"><em>Grabbed data was processed.</em></div>-->
                  <div class="text-left" v-if="scope.row.status === 10"><em>Check logbook for details.</em></div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </v-tab>
      <v-tab title="Logbook">
        <div class="row">
          <div class="col-md-11 el-col-push-1">
            <log-tabs :process_id="process_id" :server_id="serverId" :threads="threadIds"/>
          </div>
        </div>

      </v-tab>
    </vue-tabs>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import ThreadGrabChart from "./ServerStats/ThreadGrabChart";
import ThreadMdbChart from "./ServerStats/ThreadMdbChart";
import ThreadLoadChart from "./ServerStats/ThreadLoadChart";
import LogTabs from "../../Logbook/LogTabs";

export default {
  components: {LogTabs, ThreadLoadChart, ThreadMdbChart, ThreadGrabChart},
  props: ['process_id', 'stats'],
  computed: {
    serverId: function () {
      return this.stats._id;
    },
    server: function () {
      const serverId = this.serverId;
      return this.serverById()(serverId);
    },
    threadData: function () {
      const thread = this.stats.threads.find(thread => thread.thread === this.selectedThread);
      if (thread) {
        return thread.items;
      }
      return [];
    },
    threadIds: function () {
      let threadIds = [];
      if (this.stats.threads) {
        this.stats.threads.forEach(thread => threadIds.push(thread.thread))
      }
      return threadIds;
    }

  },
  data: function () {
    return {
      selectedThread: 1,
    }
  },
  methods: {
    ...mapGetters(['serverById']),
    getPercent: function (count, total) {
      let result = 0;
      if (total > 0) {
        result = Math.round((count / total) * 100);
      }
      return result;
    },
    selectThread: function (row) {
      if (row && row.thread) {
        this.selectedThread = row.thread;
      }
    },
    redrawCharts: function () {
      this.$nextTick(() => {
        const charts = [this.$refs.grabChart, this.$refs.mdbChart, this.$refs.loadChart];
        charts.forEach(chart => {
          if (chart) chart.redrawChart();
        });
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GrabProcess/View/ServerStats.vue